import * as Q from '../graphql/queries/multibss/television.query';
import { ApiResponse, query } from './api';
import * as T from './television.types';

export interface TelevisionApiInterface {
  getTvBenefits(billingCustomerId: string): ApiResponse<T.TvBenefit[]>;
  getAssignedTVBenefit(billingCustomerId: string): ApiResponse<T.AssignedBenefit>;
  setTvBenefit(billingCustomerId: string, televisionPackageId: string): Promise<T.SuccessResponse>;
  deleteAssignedTelevisionBenefit(
    billingCustomerId: string,
    televisionPackageId: string
  ): ApiResponse<T.SuccessResponse>;
}

export const TelevisionApi: TelevisionApiInterface = {
  getTvBenefits(billingCustomerId: string) {
    return query<{ getTelevisionBenefits: T.TvBenefit[] }>({
      query: Q.getTelevisionBenefitsQuery,
      variables: { billingCustomerId },
      name: 'getTelevisionBenefits',
    }).then(({ getTelevisionBenefits }) => ({
      data: getTelevisionBenefits,
    }));
  },
  getAssignedTVBenefit(billingCustomerId: string) {
    return query<{ getAssignedTelevisionBenefit: T.AssignedBenefit }>({
      query: Q.getAssignedTelevisionBenefitQuery,
      variables: { billingCustomerId },
      name: 'getAssignedTelevisionBenefit',
    }).then(({ getAssignedTelevisionBenefit }) => ({
      data: getAssignedTelevisionBenefit,
    }));
  },
  setTvBenefit(billingCustomerId: string, televisionPackageId: string) {
    return query<{ putAssignedTelevisionBenefit: T.SuccessResponse }>({
      query: Q.putAssignedTelevisionBenefitQuery,
      variables: { billingCustomerId, televisionPackageId },
      name: 'putAssignedTelevisionBenefit',
    }).then(({ putAssignedTelevisionBenefit }) => ({
      ...putAssignedTelevisionBenefit,
    }));
  },
  deleteAssignedTelevisionBenefit(billingCustomerId: string, televisionPackageId: string) {
    return query<{ deleteAssignedTelevisionBenefit: T.SuccessResponse }>({
      query: Q.deleteAssignedTelevisionBenefitQuery,
      variables: { billingCustomerId, televisionPackageId },
      name: 'deleteAssignedTelevisionBenefit',
    }).then(({ deleteAssignedTelevisionBenefit }) => ({
      data: deleteAssignedTelevisionBenefit,
    }));
  },
};
